<script>
  import { onMount } from 'svelte';

  import { navigationStore } from '../../stores';

  import AboutOctopus from './AboutOctopus.svelte';
  import AboutVoltaware from './AboutVoltaware.svelte';
  import Footer from '../../views/Footer.svelte';
  import Headline from './Headline.svelte';
  import UniquePartnership from './UniquePartnership.svelte';

  onMount(async () => {
    const hash = $navigationStore.to.hash;

    if (hash) {
      const elm = document.getElementById(hash.replace('#', ''));

      if (elm) {
        setTimeout(() => elm.scrollIntoViewIfNeeded(true), 500);
      }
    }
});


</script>

<style lang="scss">

</style>

<main>
  <Headline />
  <UniquePartnership />
  <AboutVoltaware />
  <AboutOctopus />
  <Footer />
</main>
